import { render } from "./App.vue?vue&type=template&id=d64c921e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d64c921e&lang=css"
script.render = render

export default script